/**
 * Master Editor column-sort glyph — matches Master Editor.dc.html.
 * Active: single chevron (rotates for desc). Unsorted: separate up + down carets.
 */
export default function CpmSortIcon({
    active,
    dir,
    child = false,
}: {
    active: boolean;
    dir: 'asc' | 'desc';
    /** Nested variant headers use slightly smaller glyphs. */
    child?: boolean;
}) {
    if (active) {
        const size = child ? 11 : 12;
        return (
            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={3.2}
                style={{
                    transform: dir === 'desc' ? 'rotate(180deg)' : undefined,
                    transition: 'transform 150ms ease',
                    flexShrink: 0,
                    display: 'block',
                    // Global `svg { max-width: 100% }` can crush 11–12px glyphs.
                    maxWidth: 'none',
                }}
            >
                <path d="m18 15-6-6-6 6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    }

    const size = child ? 10 : 11;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.6}
            style={{ flexShrink: 0, display: 'block', maxWidth: 'none' }}
        >
            <path d="m6 9 6-6 6 6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="m6 15 6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
